import { Option, none, isNone, some } from 'fp-ts/lib/Option';

export default interface ReadLocationCriteria {
    locationId: string;
}

class ReadLocationCriteriaImpl implements ReadLocationCriteria {
    constructor(readonly locationId: string) {}
}

export class ReadLocationCriteriaBuilder {
    private locationId: Option<string> = none;

    static create = (): ReadLocationCriteriaBuilder => new ReadLocationCriteriaBuilder();

    withLocationId = (locationId: string): ReadLocationCriteriaBuilder => {
        this.locationId = some(locationId);

        return this;
    };

    build = (): ReadLocationCriteria => {
        if (isNone(this.locationId)) {
            throw new ReferenceError('Undefined prop');
        }

        return new ReadLocationCriteriaImpl(this.locationId.value);
    };
}
